import React from "react";
import PageLayout from "../UI/PageLayout";
import { GenericReportingDropdowns } from "../../containers/GenericReportingDropdowns";
import BudgetTrackerSettingsPage from "../../containers/Settings/BudgetTrackerSettingsPage";

const BudgetPlannerSettingsPage = () => {
  return (
    <PageLayout
      title="Target Settings"
      subTitle="Configure and customize target settings and preferences"
      dropdowns={<GenericReportingDropdowns
        includeDateRange={true}
        includeSingleSelectRegion={true}
        includeGranularity={false}
        includeTooltipsAndTitles={false}
        containerStyle="dropdown-container"
        renderAsButton={true}
        includeCompareDateRange={false}
      />}
      content={<BudgetTrackerSettingsPage />}
    />
  );
};

export default BudgetPlannerSettingsPage;
